/* eslint-disable @typescript-eslint/no-explicit-any */
import {HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable, catchError, tap, throwError} from 'rxjs';
import {IApiCall} from '../../model/IApiCall';
import {AppLoggerService} from '../logger/app-logger.service';
import {AppBaseApiService} from './app-base-api.service';

@Injectable({
  providedIn: 'root',
})
export class AppHttpService {
  constructor(
    private baseApi: AppBaseApiService,
    private logger: AppLoggerService
  ) {}

  get<T>(
    resource: string,
    params:
      | HttpParams
      | {
          [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean>;
        },
    skipLoader?: boolean
  ): Observable<T> {
    const url = `${resource}`;
    return this.baseApi.apiCall<T>({url, httpParam: params, skipLoader}).pipe(
      catchError((err: any) => {
        return throwError(() => err);
      })
    );
  }

  getByUrl<T>(url: string): Observable<T> {
    return this.baseApi.apiCall<T>({url}).pipe(
      catchError((err: any) => {
        return throwError(() => err);
      })
    );
  }

  getWithOptions<T>(options: {
    url: string;
    headers: {
      [header: string]: string | string[];
    };
  }): Observable<T> {
    return this.baseApi
      .apiCall<T>({
        url: options.url,
        headers: options.headers,
        shouldAttachBaseUrl: false,
      })
      .pipe(
        catchError((err: any) => {
          return throwError(() => err);
        })
      );
  }

  getOne<T>(resource: string, id: number, skipLoader?: boolean): Observable<T> {
    const url = `${resource}/${id}`;
    return this.baseApi.apiCall<T>({url, skipLoader}).pipe(
      catchError((err: any) => {
        return throwError(() => err);
      })
    );
  }

  put<T, P>(resource: string, id: number, body: P, skipLoader?: boolean): Observable<T> {
    const url = `${resource}/${id}`;
    return this.baseApi.apiCall<T>({requestType: 'PUT', url, body, skipLoader}).pipe(
      tap((res: any) => {
        this.logger.info('Resp for put:', res);
      }),
      catchError((err: any) => {
        return throwError(() => err);
      })
    );
  }

  postWithOptions<T, P = unknown>(
    resource: string,
    body: P,
    options?: Omit<IApiCall<any>, 'url' | 'requestType' | 'body'>
  ): Observable<T> {
    const url = `${resource}`;
    return this.baseApi
      .apiCall<T>({
        requestType: 'POST',
        url,
        body,
        ...options,
      })
      .pipe(
        tap((res: any) => {
          this.logger.info(`Resp from Post with Option: Api-  ${url}`, res);
        }),
        catchError((err: any) => {
          return throwError(() => err);
        })
      );
  }

  post<T, P>(resource: string, body: P, skipLoader?: boolean): Observable<T> {
    const url = `${resource}`;
    return this.baseApi
      .apiCall<T>({
        requestType: 'POST',
        url,
        body,
        skipLoader,
      })
      .pipe(
        tap((res: any) => {
          this.logger.info('Rep from Post: ', res);
        }),
        catchError((err: any) => {
          return throwError(() => err);
        })
      );
  }

  delete<T>(resource: string, id: number): Observable<T> {
    const url = `${resource}/${id}`;
    return this.baseApi.apiCall({url, requestType: 'DELETE'});
  }
}
